import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type PoLineCreateParams = {
  quantity: number
  item: string
  po_id: number
  lead_time: string
  manufacturer_id: string
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const usePoLineCreateMutation = () =>
  useMutation<any, ErrorDTO, PoLineCreateParams>({
    mutationFn: async (values: PoLineCreateParams) => {
      try {
        const res = await client.post<ApiResponseDTO>('/po/line/create', values)

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
